module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-7.81752c60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-7.jpg
// module id = 1893
// module chunks = 2